// // src/components/Booking.js
// import React from "react";

// const vehicles = [
//   { id: 1, name: "Jeep Renegade", seats: 4, bags: 4, suv: 4, fuel: ["Petrol","Diesel","Electric"] },
//   { id: 2, name: "Ferrari Enzo", seats: 4, bags: 4, suv: 4, fuel: ["Petrol","Diesel","Electric"] },
//   { id: 3, name: "Mini Cooper", seats: 4, bags: 4, suv: 4, fuel: ["Petrol","Diesel","Electric"] },
// ];

// const Booking = () => {
//   const phoneNumber = "+919136271336"; // WhatsApp number

//   const handleBookNow = (carName) => {
//     const message = `Hi, I want to book ${carName}.`;
//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(whatsappUrl, "_blank");
//   };

//   return (
//     <>
//       <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title">Booking</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
//         <div className="container">
//           <div className="section-content">
//             <div className="twm-cars-section m-b30">
//               <div className="row">
//                 {vehicles.map((vehicle) => (
//                   <div key={vehicle.id} className="col-lg-4 col-md-6 m-b30">
//                     <div className="twm-vehicle-fleet-bx twm-custom-grid-3 text-center">
//                       <h3 className="twm-v-title">{vehicle.name}</h3>
//                       <ul className="twm-vehicle-facility">
//                         <li>
//                           <i className="fa fa-user"></i> {vehicle.seats} Seats
//                         </li>
//                         <li>
//                           <i className="fa fa-suitcase"></i> {vehicle.bags} Bags
//                         </li>
//                         <li>
//                           <i className="fa fa-car"></i> {vehicle.suv} SUV
//                         </li>
//                       </ul>
//                       <button
//                         className="book-now-btn"
//                         onClick={() => handleBookNow(vehicle.name)}
//                       >
//                         Book Now
//                       </button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Booking;


// src/components/FleetBooking.js
import React from "react";

const vehicles = [
  { id: 7, name: "Dzire", image: "images/fleet/dsire.jpg", category: "cat-1", seats: 4, bags: 4, suv: 0, fuel: ["Petrol","Diesel"] },
  { id: 5, name: "Hyundai Aura", image: "images/fleet/aura.jpg", category: "cat-5", seats: 4, bags: 4, suv: 0, fuel: ["Petrol","Diesel"] },
  { id: 8, name: "Ertiga", image: "images/fleet/ertiga.jpg", category: "cat-2", seats: 6, bags: 6, suv: 0, fuel: ["Petrol","Diesel"] },
  { id: 1, name: "Kia Carens", image: "images/fleet/kia.jpg", category: "cat-1", seats: 6, bags: 6, suv: 0, fuel: ["Petrol","Diesel"] },
  { id: 10, name: "Innova Crysta", image: "images/fleet/innova-crysta.jpg", category: "cat-4", seats: 7, bags: 7, suv: 1, fuel: ["Diesel"] },
  { id: 2, name: "Mini Bus", image: "images/fleet/mini-bus.jpg", category: "cat-2", seats: 12, bags: 10, suv: 0, fuel: ["Diesel"] },
  { id: 3, name: "Tempo Traveller", image: "images/fleet/tempo-traveller.jpg", category: "cat-3", seats: 14, bags: 12, suv: 0, fuel: ["Diesel"] },
  { id: 4, name: "Urbania", image: "images/fleet/urbania.jpg", category: "cat-4", seats: 9, bags: 6, suv: 0, fuel: ["Diesel"] },
  { id: 6, name: "Bus", image: "images/fleet/bus.jpg", category: "cat-6", seats: 20, bags: 15, suv: 0, fuel: ["Diesel"] },
  { id: 9, name: "Fortuner", image: "images/fleet/fortuner.jpg", category: "cat-3", seats: 7, bags: 5, suv: 1, fuel: ["Diesel","Petrol"] },
];

const Booking = () => {
  const phoneNumber = "+919136271336"; // WhatsApp number

  const handleBookNow = (carName) => {
    const message = `Hi, I want to book ${carName}.`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Online Booking</h2>
            </div>
          </div>
        </div>
      </div>

    <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
      <div className="container">
        {/* <div className="section-head center">
          <div className="twm-sm-title left">Our Fleet</div>
          <h2 className="twm-large-title site-text-dark">Book Your Ride</h2>
        </div> */}

        <div className="section-content">
          <div className="row">
            {vehicles.map((vehicle) => (
              <div key={vehicle.id} className="col-lg-4 col-md-6 m-b30">
                <div className="twm-vehicle-fleet-bx twm-custom-grid-3 text-center ">
                  <div className="twm-media ">
                    <img src={vehicle.image} alt={vehicle.name} />
                  </div>
                  <div className="twm-vehicle-fleet-content borr">
                    <h3 className="twm-v-title">{vehicle.name}</h3>
                    <ul className="twm-vehicle-facility">
                      <li><i className="fa fa-user"></i> &nbsp;{vehicle.seats} Seats</li>
                      <li><i className="fa fa-suitcase"></i>&nbsp; {vehicle.bags} Bags</li>
                      {/* {vehicle.suv ? <li><i className="fa fa-car"></i>&nbsp; SUV</li> : null} */}
                      <li><i className="fa fa-tachometer"></i>&nbsp; {vehicle.fuel.join(", ")}</li>
                    </ul>
                    <button
                      className="book-now-btn"
                      onClick={() => handleBookNow(vehicle.name)}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    
    </>
  );
};

export default Booking;